var version = {
    "name":      "dativery",
    "buildDateCode": "20260316-134633",
    "buildDate": "Mon Mar 16 2026 13:46:33 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260316-134633",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;